import { PropsWithChildren, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { ACCESS_DENIED_ROUTE } from "../../../constants/routes";
import { useAppSelector } from "../../store/storeHooks";
import { UserType } from '../../login/loginTypes';
import { selectUserType } from "../../login/loginSelectors";
import { AccessDeniedState } from "../pages/AccessDenied";

type RequireUserTypeProps = Readonly<PropsWithChildren<{
    userType: UserType
}>>

export function RequireUserType({ userType: requiredUserType, children }: RequireUserTypeProps) {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const actualUserType = useAppSelector(selectUserType)

    useEffect(() => {
        if (actualUserType !== requiredUserType) {
            const state: AccessDeniedState = {
                requiredUserType,
                actualUserType,
                path: pathname,
            }
            navigate(ACCESS_DENIED_ROUTE, { state })
        }
    }, [requiredUserType, actualUserType])

    // NOTE: Do NOT render outlet if unauthorized!
    if (actualUserType !== requiredUserType) {
        return null
    }

    return (
        <Outlet />
    )
}
